import { createAction, props } from '@ngrx/store';
import { SafeLinksPolicy } from './model';

export const loadSafeLinksPolicy = createAction('[Client/Pwsh/Exo] Load SafeLinksPolicy', props<{ _tenant: string }>());

export const loadSafeLinksPolicySuccess = createAction(
    '[Client/Pwsh/Exo] Load SafeLinksPolicy Success',
    props<{ _tenant: string; data: SafeLinksPolicy[] }>(),
);

export const loadSafeLinksPolicyFailure = createAction(
    '[Client/Pwsh/Exo] Load SafeLinksPolicy Failure',
    props<{ _tenant: string; error: any }>(),
);

export const createExoSafeLinksPolicy = createAction(
    '[Client/Pwsh/Exo] Create SafeLinksPolicy',
    props<{ _tenant: string; data: Partial<SafeLinksPolicy> }>(),
);

export const createExoSafeLinksPolicySuccess = createAction(
    '[Client/Pwsh/Exo] Create SafeLinksPolicy Success',
    props<{ _tenant: string; data: SafeLinksPolicy }>(),
);

export const createExoSafeLinksPolicyFailure = createAction(
    '[Client/Pwsh/Exo] Create SafeLinksPolicy Failure',
    props<{ _tenant: string; error: any }>(),
);

export const updateExoSafeLinksPolicy = createAction(
    '[Client/Pwsh/Exo] Update SafeLinksPolicy',
    props<{ _tenant: string; data: Partial<SafeLinksPolicy> }>(),
);

export const updateExoSafeLinksPolicySuccess = createAction(
    '[Client/Pwsh/Exo] Update SafeLinksPolicy Success',
    props<{ _tenant: string; data: SafeLinksPolicy }>(),
);

export const updateExoSafeLinksPolicyFailure = createAction(
    '[Client/Pwsh/Exo] Update SafeLinksPolicy Failure',
    props<{ _tenant: string; error: any }>(),
);
